module.exports = __webpack_public_path__ + "img/p2-39.0a3ca2ee.png";